module.exports = __webpack_public_path__ + "img/icon2.ff5c5ae7.png";